import {defineMessages} from "react-intl";

export default defineMessages({
    accessList: {id: 'accesses.accessList', defaultMessage: 'ACCESS LIST', description: 'Accesses: ACCESS LIST'},
})